import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import HttpClient from '../../api/api';
import {FavoriteFilter, FavoriteFilterScope} from './types';

export interface FavoriteFiltersState {
    items: FavoriteFilter[];
    activeId: number | null;
}

const initialState: FavoriteFiltersState = {
    items: [],
    activeId: null
}

export const getFavoriteFilters = createAsyncThunk(
    'favoriteFilters/get-many',
    async (scope: FavoriteFilterScope) => {
        const response = await HttpClient.favoriteFiltersApi.getMany<FavoriteFilter[]>(scope);
        return response.data;
    }
)

export const createFavoriteFilter = createAsyncThunk(
    'favoriteFilters/create',
    async (data: {scope: FavoriteFilterScope, name: string, filterPayload: string}) => {
        const response = await HttpClient.favoriteFiltersApi.create(data);
        return response.data;
    }
)

export const deleteFavoriteFilter = createAsyncThunk(
    'favoriteFilters/delete',
    async (id: number) => {
        await HttpClient.favoriteFiltersApi.delete<FavoriteFilter>(id);
        return id;
    }
)

const favoriteFiltersSlice = createSlice({
    name: 'favoriteFilters',
    initialState,
    reducers: {
        setActiveFavoriteFilter: (state, action: PayloadAction<number | null>) => {
            state.activeId = action.payload;
        },
        clearFavoriteFilters: (state) => {
            state.items = initialState.items;
            state.activeId = initialState.activeId;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getFavoriteFilters.fulfilled, (state, action) => {
            state.items = action.payload;
        });
        builder.addCase(createFavoriteFilter.fulfilled, (state, action) => {
            state.items.push(action.payload);
            state.activeId = action.payload.id;
        });
        builder.addCase(deleteFavoriteFilter.fulfilled, (state, action) => {
            state.items = state.items.filter(item => item.id !== action.payload);
            if (state.activeId === action.payload) {
                state.activeId = null;
            }
        });
    }
})

export const { setActiveFavoriteFilter, clearFavoriteFilters } = favoriteFiltersSlice.actions;

export default favoriteFiltersSlice.reducer;
